import IconToolTip from "@/Components/Icon/IconToolTip";
import { useSetPosModal } from "@/shared/atoms/usePosModal";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import { useTranslation } from "react-i18next";

const LiveMobilePosButton = () => {
  const isMobile = useIsMobileHook();
  const setIsPosOrderOpen = useSetPosModal();
  const { t } = useTranslation("");
  return (
    isMobile && (
      <div onClick={() => setIsPosOrderOpen(true)} className="flex">
        <IconToolTip
          variants="cashRegister"
          className="fill-dark"
          text={t("livePosOrder")}
        />
      </div>
    )
  );
};

export default LiveMobilePosButton;
